var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__a",
    d: "M20 0c11.06 0 20 8.94 20 20s-8.94 20-20 20S0 31.06 0 20 8.94 0 20 0zm-1.997 10.173l-8.69 15.3C8.425 27.035 9.533 29 11.31 29h17.38c1.778 0 2.885-1.964 1.997-3.528l-8.69-15.299a2.286 2.286 0 00-3.994 0zm3.151 12.947v2.352h-2.308V23.12h2.308zM20 16.065c.635 0 1.154.529 1.154 1.175v2.352c0 .647-.52 1.176-1.154 1.176a1.168 1.168 0 01-1.154-1.176V17.24c0-.646.52-1.175 1.154-1.175z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FB9800",
    fillRule: "evenodd",
    xlinkHref: "#warning_svg__a"
  })));
};
export default __webpack_public_path__ + "static/media/warning.fb51b03c.svg";
export { SvgWarning as ReactComponent };